module.exports = __webpack_public_path__ + "static/media/_A3I2609.92f1510f.jpg";